import { Component ,Input} from '@angular/core';

@Component({
  selector: 'app-spinnerr',
  templateUrl: './spinnerr.component.html',
  styleUrls: ['./spinnerr.component.scss']
})
export class SpinnerrComponent {
  @Input() value: number = 100;
  @Input() diameter: number = 70;
  @Input() mode: string = "determinate";
  @Input() strokeWidth: number = 10;
  @Input() overlay: boolean = false;
  @Input() color: string = "primary";

}
